{
  "axes": {
    "inputsCovered": "Eingaben abgedeckt",
    "needsPerson": "Personeneingabe nötig",
    "withLlm": "Mit LLM",
    "withoutLlm": "Ohne LLM"
  },
  "changes": {
    "abstractStepAdded": "abstrakter Schritt <step/> ({{role}})",
    "bindingAdded": "Verbindung <target/> ← <source/>",
    "bindingChanged": "Verbindung <target/>: <before/> → <after/>",
    "bindingRemoved": "Verbindung <target/> ← <source/>",
    "defaultAdded": "Standardwert <target/> = {{value}}",
    "defaultChanged": "Standardwert <target/>: {{before}} → {{after}}",
    "defaultRemoved": "Standardwert <target/> = {{value}}",
    "definitionBound": "<step/> bindet <abstractStep/>: <before/> → <after/>",
    "exportAdded": "Ergebnis {{name}} ← <source/>",
    "exportChanged": "Ergebnis {{name}}: <before/> → <after/>",
    "exportRemoved": "Ergebnis {{name}} ← <source/>",
    "none": "Noch keine Änderungen.",
    "roleChanged": "<step/> Schrittrolle: {{before}} → {{after}}",
    "startChanged": "<step/> Start: {{before}} → {{after}}",
    "stepAdded": "Schritt <step/> ({{role}})",
    "stepMoved": "<step/> verschoben",
    "stepRemoved": "Schritt <step/>",
    "stepRepinned": "<before/> → <after/>",
    "subWorkflowAdded": "Teilprozessschema <step/> ({{role}})",
    "textsChanged": "Name oder Beschreibung",
    "unbound": "nichts"
  },
  "context": {
    "access": {
      "file": "Datei",
      "search": "Suchwerkzeug",
      "selection": "Auswahl",
      "session": "Sitzung",
      "step_input": "Schritteingabe",
      "whole": "ganz"
    },
    "accessHelp": {
      "file": "Das Werkzeug liest die Datei selbst; nichts gelangt in den Kontext eines LLM.",
      "search": "Ein MCP-Werkzeug, das der Agent bei Bedarf aufruft; nur die Ergebnisse gelangen in den Kontext.",
      "selection": "Eine Auswahlregel wählt einen Teil davon aus, innerhalb ihrer Grenze.",
      "session": "Die Agentensitzung behält es von Zug zu Zug.",
      "step_input": "Die Ausgabe eines früheren Schritts, so groß, wie sie in jenem Durchlauf entstand.",
      "whole": "Wird vollständig in den Kontext eingefügt."
    },
    "agentLimits": "Höchstens {{rounds}} und {{runs}}, {{seconds}} s.",
    "card": {
      "agent": "≈ {{tokens}} Tokens bekannt · {{tools}}",
      "model": {
        "embedding": "lokales Embedding",
        "none": "kein Embedding-Modell",
        "unknown": "Nutzung eines Embedding-Modells unbekannt"
      },
      "tool": "{{model}} · {{seconds}} s",
      "toolCount_one": "{{count}} Werkzeug",
      "toolCount_other": "{{count}} Werkzeuge",
      "toolNoTimeout": "{{model}}"
    },
    "compaction": {
      "fit_to_budget_one": "Ans Budget angepasst: höchstens {{count}} Eingabe-Token.",
      "fit_to_budget_other": "Ans Budget angepasst: höchstens {{count}} Eingabe-Tokens.",
      "none": "Keine Kontextverdichtung.",
      "other": "Kontextverdichtung {{method}}@{{version}}."
    },
    "contextWindow_one": "Braucht einen Kontext von {{count}} Token.",
    "contextWindow_other": "Braucht einen Kontext von {{count}} Tokens.",
    "find": {
      "button": "Artefakt finden…",
      "search": "Artefakte durchsuchen",
      "unused": "Kein Schritt dieses Prozessschemas liest oder schreibt es.",
      "usedBy_one": "Genutzt von Schritt {{steps}}.",
      "usedBy_other": "Genutzt von den Schritten {{steps}}."
    },
    "from": "aus <step/>, <part/>",
    "grantedWithSkills": "mit Skills",
    "intro": "Je Schritt: was er liest und schreibt, wie, und was in den Kontext eines Agenten gelangt. Größen gelten für die neueste Inhaltsversion; Tokens sind geschätzt, mit 4 Zeichen je Token.",
    "knownTokens_one": "≈ {{count}} Token vor einem Durchlauf bekannt",
    "knownTokens_other": "≈ {{count}} Tokens vor einem Durchlauf bekannt",
    "legend": {
      "access": "Wie es gelesen wird",
      "resources": "Was gelesen wird",
      "title": "Legende",
      "tokens": "Die Token-Angaben zählen den eigenen Text des Prompts und ganz gelesene Inhalte bekannter Größe; Eingaben aus früheren Schritten und Auswahlen sind erst in einem Durchlauf bekannt. Würde die Eingabe ihr Budget überschreiten, werden die Platzhalter in der gezeigten Reihenfolge gekürzt."
    },
    "limits": {
      "examples_by_items": "{{value}} fixiert",
      "examples_by_ranking": "sortiert nach {{value}}",
      "examples_by_tags": "Tags {{value}}",
      "filter": "Filter {{value}}",
      "include_examples": "Beispiele {{value}}",
      "include_guidelines": "Richtlinien {{value}}",
      "include_notes": "Notizen {{value}}",
      "include_sparql": "SPARQL {{value}}",
      "maximum_examples": "höchstens {{value}}",
      "modules": "{{value}} Ontologiemodule",
      "path": "{{value}}",
      "render": "als {{value}}",
      "scope": "Bereich {{value}}",
      "tags": "Tags {{value}}",
      "term_kinds": "{{value}}"
    },
    "loading": "Was die Schritte lesen, wird ermittelt…",
    "names": {
      "accepted_instance_data": "Die angenommenen Aussagen des Projekts",
      "competency_questions": "Kompetenzfragen",
      "corpus_documents": "Die Dokumente der Korpusversion",
      "derived_records": "Gespeicherte Vektoren der Korpusversion",
      "few_shot_examples": "Few-shot-Beispiele",
      "ontology_terms": "Ontologiebegriffe",
      "outputs": "Seine Ausgaben",
      "propose": "Eine vorgeschlagene Version eines Elements",
      "reference_vocabularies": "Die Referenzvokabulare des Projekts",
      "session": "Frühere Züge",
      "source_scope": "Eine Quellenauswahl",
      "source_version": "Die gebundene Quellversion des Durchlaufs",
      "subject": "Das Dokument oder Segment des Durchlaufs"
    },
    "nothing": "Nichts.",
    "ownTokens_one": "≈ {{count}} Token eigener Text",
    "ownTokens_other": "≈ {{count}} Tokens eigener Text",
    "panelLabel": "Was jeder Schritt liest und in den Kontext gibt",
    "placeholders": "Platzhalter",
    "promptTokens_one": "Eigener Text des Prompts: ≈ {{count}} Token.",
    "promptTokens_other": "Eigener Text des Prompts: ≈ {{count}} Tokens.",
    "reads": "Liest",
    "reducedAt": "als {{position}}. gekürzt",
    "resourceHelp": {
      "artifact": "Ein Projektelement, ganz gelesen.",
      "change_sets": "Vorgeschlagene Änderungen und ihre Prüfungen.",
      "corpus": "Das Dokument, um das es im Durchlauf geht, oder eine Quellenauswahl des Korpus.",
      "earlier_step": "Die Ausgabe eines früheren Schritts im Durchlauf.",
      "examples": "Few-shot-Beispiele.",
      "label_list": "Die Labels, die ein Annotationsschritt nutzt.",
      "model": "Ontologiemodule und Kompetenzfragen der Inhaltsversion.",
      "process_items": "Prompts, Schritte, Prozessschemata und Werkzeuge des Projekts.",
      "reference_vocabularies": "Nach Projektdatenrolle gebundene Vokabulare: herangezogen, nie importiert.",
      "skills": "Die Skills des Schritts.",
      "step_output": "Das eigene Ergebnis des Schritts.",
      "thread_history": "Frühere Züge und Einträge des Durchlaufs.",
      "workspace_files": "Eine Datei, die ein Werkzeug im Arbeitsbereich des PCs liest, auf dem der Durchlauf läuft."
    },
    "resources": {
      "artifact": "Artefakt",
      "change_sets": "Änderungssätze",
      "corpus": "Korpus",
      "earlier_step": "Früherer Schritt",
      "examples": "Beispiele",
      "knowledge_data": "Wissensdaten",
      "label_list": "Labelliste",
      "model": "Datenmodell",
      "process_items": "Prozesselemente",
      "reference_vocabularies": "Referenzvokabulare",
      "skills": "Skills",
      "step_output": "Schrittausgabe",
      "thread_history": "Durchlauf-Verlauf",
      "workspace_files": "Datei im Arbeitsbereich"
    },
    "sections": "Abschnitte des Prompts",
    "session": {
      "isolated": "Eigene Sitzung: keine früheren Züge.",
      "thread": "Durchlauf-Sitzung: frühere Züge bleiben im Kontext des Agenten."
    },
    "size": {
      "items_one": "{{count}} Element",
      "items_other": "{{count}} Elemente",
      "terms_one": "{{count}} Begriff",
      "terms_other": "{{count}} Begriffe",
      "unknown": "Größe erst im Durchlauf bekannt"
    },
    "skills_one": "{{count}} Skill, bei Bedarf gelesen",
    "skills_other": "{{count}} Skills, bei Bedarf gelesen",
    "stepPage": "Definition des Schritts",
    "stepPageNamed": "Schritt {{name}} öffnen",
    "toggle": "Ressourcen und Kontext",
    "tool": {
      "builtIn": "Eingebautes Werkzeug {{tool}}, vom Server ausgeführt.",
      "item": "Werkzeug {{tool}} in der Sandbox {{runtime}}.",
      "limits": "Zeitlimit {{seconds}} s · Speicher {{memory}} MB · Ausgabe {{output}} MB",
      "model": {
        "embedding": "Lokales Embedding-Modell {{model}}.",
        "none": "Kein Embedding-Modell.",
        "unknown": "Nutzung eines Embedding-Modells unbekannt."
      },
      "unknownLimit": "?"
    },
    "toolRounds_one": "{{count}} Werkzeugrunde",
    "toolRounds_other": "{{count}} Werkzeugrunden",
    "toolRuns_one": "{{count}} Werkzeuglauf",
    "toolRuns_other": "{{count}} Werkzeugläufe",
    "tools": "Angebotene MCP-Werkzeuge, bei Bedarf gelesen",
    "unbound": "in diesem Prozessschema nicht verbunden",
    "unreadable": "Die Definition dieses Schritts konnte nicht gelesen werden.",
    "untitledSection": "Vor der ersten Überschrift",
    "writes": "Schreibt",
    "writesMarker": "schreibt"
  },
  "density": {
    "help": {
      "compact": "Nur Art und Name",
      "detailed": "Auch, was jeder Schritt tut; alle Eingaben sind aufgeklappt",
      "standard": "Art, Name und eine wichtige Angabe"
    },
    "label": "Wie viel jede Karte zeigt",
    "options": {"compact": "Kompakt", "detailed": "Ausführlich", "standard": "Standard"},
    "short": "Karten:"
  },
  "details": {
    "after": "{{start}}, nach Schritt {{step}}",
    "budget": "Höchstens {{count, number}} Eingabe-Tokens.",
    "capabilities": {
      "reasoning": "Reasoning",
      "text": "Text",
      "tools": "Werkzeuge",
      "vision": "Bilder"
    },
    "contextWindow": "einen Kontext von {{count, number}} Tokens",
    "corpus": "das Korpus",
    "earlierResults": "frühere Ergebnisse dieses Durchlaufs",
    "editNamed": "{{name}} bearbeiten",
    "entry": "Das bearbeitete Dokument oder Segment",
    "fromStep": "aus Schritt {{step}}, {{part}}",
    "givesAnnotations": {
      "content_change_set": "Annotationen, {{need}}, als Inhalts-Änderungssatz gespeichert",
      "knowledge_data": "Annotationen, {{need}}, in die Wissensdaten gespeichert",
      "thread_log": "Annotationen, {{need}}, im Durchlauf behalten"
    },
    "givesChangeSet": "ein Änderungssatz mit {{kinds}}, {{need}}",
    "givesInstanceData": "Aussagen, {{need}}",
    "givesText": "eine Antwort als Text",
    "labels": {
      "agent": "Agent",
      "answer": "Antwort",
      "asks": "Bittet",
      "does": "Tut",
      "filled": "Gefüllt mit",
      "from": "Aus",
      "gives": "Gibt",
      "holds": "Enthält",
      "kind": "Art",
      "madeBy": "Erstellt von",
      "mayCall": "Darf aufrufen",
      "prompt": "Prompt",
      "reads": "Liest",
      "skills": "Skills",
      "starts": "Startet",
      "tool": "Werkzeug",
      "version": "Version",
      "with": "Mit"
    },
    "list": "{{first}} und {{last}}",
    "needs": "Braucht {{needs}}.",
    "openPrompt": "Prompt öffnen",
    "promptVersion": "Prompt {{version}}",
    "proposes": "schlägt „{{name}}“ zum Review vor",
    "render": {"numbered_segments": "in nummerierten Segmenten", "plain": "als reiner Text"},
    "sections_one": "({{count}} Abschnitt)",
    "sections_other": "({{count}} Abschnitte)",
    "session": {
      "isolated": "Eigene Sitzung.",
      "thread": "Durchlauf-Sitzung: frühere Züge bleiben in ihrem Kontext."
    },
    "shortenedFirst": "Zuerst gekürzt: {{inputs}}.",
    "skillUse": {"offered": "angeboten", "requested": "angefordert"},
    "start": {"automatic": "Automatisch", "on_request": "Auf Anforderung"},
    "stepVersion": "Schrittversion {{version}}",
    "termFilter": {
      "all": "alle Begriffe",
      "labels_matching_subject": "Begriffe, deren Bezeichnungen zum Dokument oder Segment passen"
    },
    "unbound": "nichts gebunden",
    "whole": "ganz",
    "wholeContentVersion": "die ganze Inhaltsversion",
    "wholeDataModel": "das ganze Datenmodell"
  },
  "edit": {
    "about": "Allgemein",
    "aboutDescription": "Beschreibung",
    "aboutName": "Name",
    "addExport": "Ergebnis hinzufügen",
    "addInput": "+ Eingabe",
    "addInputNamed": "{{name}} als Eingabe hinzufügen",
    "addMain": "+ Hauptablauf",
    "addMainNamed": "{{name}} zum Hauptablauf hinzufügen",
    "added": "{{name}} hinzugefügt ({{role}}).",
    "bound": "{{target}} ← {{source}} verbunden.",
    "changeSetTitle": "Prozessschema ändern: {{name}}",
    "changedChip": "geändert",
    "changes": "Änderungen in diesem Entwurf",
    "close": "Editor schließen",
    "defaultValue": "Standardwert",
    "discard": "Verwerfen",
    "discarded": "Der Entwurf ist wieder auf der Ausgangsversion.",
    "editStep": "Schritt bearbeiten…",
    "exportName": "Name des Ergebnisses",
    "exportNameProblem": "Einen neuen Namen aus Kleinbuchstaben, Ziffern und _ wählen.",
    "exportPart": "Teil",
    "exports": "Ergebnisse des Prozessschemas",
    "graphLabel": "Prozessschema-Graph, Bearbeitung",
    "inThread": "Im Durchlauf bearbeiten…",
    "inputs": "Eingaben",
    "invalidBinding": "{{source}} (passt nicht)",
    "key": "Schlüssel {{key}}",
    "loading": "Editor wird geöffnet…",
    "moveEarlier": "Nach vorn",
    "moveLater": "Nach hinten",
    "newStep": "Neuer Schritt…",
    "noExports": "Keine Ergebnisse: Ein Prozessschema, das dieses als Teilprozessschema nutzt, erhält keine seiner Ausgaben.",
    "noOtherInputs": "keine in diesem Prozessschema",
    "noSources": "Keine frühere Ausgabe passt zu dieser Eingabe.",
    "notSaved": "nicht gespeichert",
    "nothingToAdd": "Der Entwurf hat noch keine Änderungen.",
    "open": "Bearbeiten…",
    "openSubWorkflow": "Teilprozessschema öffnen",
    "paletteHint": "Auf den Hauptablauf oder die Eingabevorbereitung darüber ziehen, oder die Knöpfe nutzen. Ein Prozessschema wird zum Teilprozessschema.",
    "picker": {
      "empty": "Es gibt noch keine Schritte zum Hinzufügen.",
      "gives": "Gibt",
      "groups": {"own": "Dieses Projekt", "workflows": "Prozessschemata, als Teilprozessschemata"},
      "library": "Bibliothek: {{name}}",
      "loading": "Die Schritte, die dieses Projekt nutzen kann, werden gelesen …",
      "noMatch": "Kein Schritt passt zur Suche.",
      "nothing": "nichts",
      "search": "Nach Name oder Typ suchen",
      "takes": "Nimmt",
      "title": "Schritt hinzufügen"
    },
    "problemChip_one": "{{count}} Problem",
    "problemChip_other": "{{count}} Probleme",
    "problemsNotice": "Der Entwurf hat Probleme. Er kann trotzdem als Zwischenstand in einen Änderungssatz; das Review zeigt sie.",
    "problems_one": "{{count}} Problem",
    "problems_other": "{{count}} Probleme",
    "proposed": "vorgeschlagen",
    "reading": "Schrittversionen werden gelesen…",
    "refusals": {
      "kindsDoNotFit": "Hier nicht möglich: {{target}} nimmt keine der Arten {{kinds}}. Eingaben, die passen: {{others}}.",
      "noSuchPart": "{{source}} geht nicht: Der Schritt hat keine solche Ausgabe.",
      "noSuchSlot": "{{target}} geht nicht: Der Schritt hat keine solche Eingabe.",
      "noSuchStep": "{{target}} geht nicht: Der Schritt ist nicht in diesem Prozessschema.",
      "notEarlier": "{{target}} ← {{source}} geht nicht: Die Quelle muss ein früherer Schritt sein.",
      "sameStep": "{{target}} kann nicht mit dem eigenen Schritt verbunden werden.",
      "unknownPorts": "Noch nicht möglich: Die Schrittversionen werden noch gelesen."
    },
    "remove": "Entfernen",
    "removeExportNamed": "Ergebnis {{name}} entfernen",
    "repinned_one": "{{keys}} führt jetzt die neue Schrittversion aus.",
    "repinned_other": "{{keys}} führen jetzt die neue Schrittversion aus.",
    "reviewNotice": "Die Prüfungen laufen auf dem aktuellen Stand des Änderungssatzes; Kuratorinnen und Kuratoren von Prozessschemata entscheiden.",
    "role": "Schrittrolle",
    "roles": {"input": "Eingabevorbereitung", "main": "Hauptablauf"},
    "saved": "in einem Änderungssatz",
    "selectHint": "Wählen Sie im Graphen den Namen eines Schritts, um Schrittrolle, Start und Eingaben festzulegen. Zum Verbinden von einer Ausgabe (rechts oder unten an einer Karte) zu einer Eingabe (links oder oben an einer Karte) ziehen.",
    "selectNamed": "{{name}} auswählen",
    "start": "Start",
    "starts": {"automatic": "automatisch", "on_request": "auf Anforderung"},
    "status": "Entwurf von @{{version}}",
    "stepVersion": "Schritt",
    "toolbar": "Editor",
    "unbound": "nicht verbunden",
    "workflowVersion": "Teilprozessschema"
  },
  "graph": {
    "controls": "Zoomsteuerung",
    "edgeHint": "Verbindung zwischen zwei Schritten.",
    "fitView": "Graph an die Fläche anpassen",
    "label": "Prozessschema-Graph",
    "nodeHint": "Mit den Schaltflächen und Links im Schritt öffnen Sie ihn oder seine Eingaben.",
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern"
  },
  "index": {
    "intro": "Wählen Sie ein Prozessschema in der Seitenleiste.",
    "new": "Etwas Neues anlegen"
  },
  "inputCard": {
    "edit": "Bearbeiten",
    "shownAs": "Angezeigt als {{view}}; nur {{type}} passt",
    "version": "Version {{version}}"
  },
  "layout": {
    "help": {
      "horizontal": "Die Schritte laufen von links nach rechts",
      "vertical": "Die Schritte laufen von oben nach unten"
    },
    "label": "In welche Richtung die Schritte laufen",
    "options": {"horizontal": "Waagerecht", "vertical": "Senkrecht"},
    "short": "Richtung:"
  },
  "legend": {
    "help": "Was jedes Zeichen bedeutet",
    "label": "Was die Zeichen bedeuten",
    "meanings": {
      "inputNeed": "Durchgezogener Rand: Ein Wert muss vorliegen, bevor der Schritt läuft; ein Standardwert kann ihn liefern. Gepunktet: Der Schritt läuft auch ohne.",
      "passesResult": "Die Ausgabe eines früheren Schritts füllt diese Eingabe. Die Linie trägt einen Wert.",
      "personInput": "Eine Person gibt eine der Eingaben dieses Schritts, bevor er läuft: Kein früherer Schritt, kein Standardwert und keine Daten des Durchlaufs decken sie ab.",
      "portLabel": "Wofür der Anschluss da ist, dann in Worten, was er nimmt oder gibt, etwa Text oder Annotationen. „Typ nicht deklariert“: Die Definition des Schritts nennt keinen.",
      "readsSaved": "Eine gespeicherte oder vorbereitete Eingabe aus der Reihe darüber füllt diese Eingabe. Auch das sind Daten.",
      "then": "Dieser Schritt folgt auf jenen. Die Linie übergibt keinen Wert.",
      "unused": "Nichts in diesem Prozessschema nutzt diese Ausgabe. Die Ausgabe fehlt nicht, und der Schritt ist nicht optional.",
      "waitsForRun": "Dieser Schritt startet erst, wenn Sie Ausführen wählen. Seine Datenlinien behalten ihren eigenen Stil."
    },
    "portSample": "corpus · Text",
    "rule": "Kreise sind Anschlüsse. Pfeile zeigen die Richtung. Kreuzungen verbinden nicht.",
    "samples": {
      "inputNeed": "Erforderliche, optionale Eingabe",
      "passesResult": "Übergibt ein Ergebnis",
      "portLabel": "Name · Datentyp",
      "readsSaved": "Liest eine gespeicherte Eingabe",
      "then": "Dann",
      "unused": "Ausgabe später nicht genutzt",
      "waitsForRun": "Optional, auf Anfrage"
    }
  },
  "library": {
    "empty": "Dieses Projekt hat noch keine Prozessschemata. Erstellen Sie eines aus einem Durchlauf oder schlagen Sie eines in einem Änderungssatz vor.",
    "loading": "Prozessschemata werden geladen …"
  },
  "list": {
    "groups": {
      "basis": "DMW-Basis",
      "favourites": "Favoriten",
      "kind": "{{origin}} · {{kind}}",
      "parts_one": "{{count}} Teil anderer Prozessschemata",
      "parts_other": "{{count}} Teile anderer Prozessschemata",
      "project": "Dieses Projekt",
      "recent": "Zuletzt verwendet"
    },
    "noMatch": "Kein Prozessschema passt zur Suche.",
    "partOf": "Teil von {{workflows}}",
    "search": "Prozessschemata durchsuchen",
    "star": "{{workflow}} zu den Favoriten hinzufügen",
    "unstar": "{{workflow}} aus den Favoriten entfernen"
  },
  "node": {
    "allQuestions": "Alle Kompetenzfragen",
    "builtBy": "Erstellt von einem Durchlauf von „{{workflow}}“; diese Version wurde von Hand erstellt",
    "builtInTool": "Eingebautes Werkzeug {{tool}}",
    "collapse": "Zuklappen",
    "collapseNamed": "{{name}} zuklappen",
    "expand": "Aufklappen",
    "expandNamed": "{{name}} aufklappen",
    "facts": {
      "annotations": "Schreibt Annotationen mit den Labels",
      "annotationsToData": "Schreibt Annotationen in die Wissensdaten",
      "answer": "Schreibt eine Antwort",
      "builtInTool": "Eingebautes {{tool}}, {{model}}",
      "changeSet": "Schlägt einen Änderungssatz zur Kuratierung vor",
      "changeSetOptional": "Kann einen Änderungssatz zum Review vorschlagen",
      "choice": "Wählt eines von: {{options}}",
      "decideResults": "Kuratierende nehmen das Ergebnis an oder lehnen es ab",
      "examples": {
        "all": "alle Beispiele",
        "matching_subject": "Beispiele, die zum Dokument oder Segment passen"
      },
      "fewShot_one": "Höchstens {{count}} Beispiel",
      "fewShot_other": "Höchstens {{count}} Beispiele",
      "instanceData": "Schreibt Aussagen zum Review",
      "itemWhole": "Wird ganz gelesen",
      "keepMemory": "Eine Person behält die Passagen als Erinnerung",
      "labels_one": "{{count}} Label",
      "labels_other": "{{count}} Labels",
      "proposeChange": "Bearbeiten und als Änderungssatz speichern",
      "questions_one": "{{count}} Frage",
      "questions_other": "{{count}} Fragen",
      "releasePart": "Füllt die Veröffentlichungsanfrage aus: {{part}}",
      "review": "Korrigieren und bestätigen, Kommentar optional",
      "reviewChangeSet": "Kuratierende entscheiden über den Änderungssatz",
      "reviewMemory": "Wer bestätigen darf, bestätigt oder verwirft die Erinnerung",
      "reviewWithComment": "Korrigieren und bestätigen, mit Kommentar",
      "subWorkflow_one": "{{count}} Schritt: {{steps}}",
      "subWorkflow_other": "{{count}} Schritte: {{steps}}",
      "taggedQuestions": "Mit den Tags {{tags}}",
      "termProperties": "Mit {{properties}}",
      "termPropertiesFrom": "Mit den Eigenschaften, die „{{item}}“ nennt",
      "termRender": {"term_cards": "Als Begriffskarten", "turtle": "Als Turtle"},
      "text": "Antwortet als Text",
      "tool": "{{tool}}, {{model}}",
      "unboundOptional": "Darf leer bleiben",
      "withGuidelines": "mit Richtlinien",
      "withSparql": "mit SPARQL",
      "withoutSparql": "ohne SPARQL",
      "workspaceFile": "Reicht eine Datei ein ({{suffixes}})"
    },
    "gives": "Gibt {{ports}}",
    "hideSettingsNamed": "Einstellungen von {{name}} ausblenden",
    "isCollapsed": "Zugeklappt",
    "isExpanded": "Aufgeklappt",
    "isInput": "Eingabevorbereitung",
    "kinds": {
      "abstract_step": "Abstrakter Schritt",
      "artifact": "Artefakt",
      "sub_workflow": "Teilprozessschema",
      "terms": "Ontologiebegriffe",
      "unreadable": "Nicht lesbar"
    },
    "madeBy": "Erstellt von einem Durchlauf von „{{workflow}}“",
    "madeByHand": "Von Hand erstellt",
    "number": "Schritt {{number}}",
    "onRequest": "Optional, auf Anfrage",
    "openProducer": "Prozessschema",
    "openProducerNamed": "Prozessschema öffnen, das {{name}} erstellt",
    "openProducerThread": "Durchlauf",
    "openProducerThreadNamed": "Durchlauf öffnen, der {{name}} erstellt hat",
    "port": {
      "empty": "(leer)",
      "many": "Mehrere: {{type}}",
      "needs": {
        "optional": "Optional",
        "required": "Erforderlich",
        "undeclared": "Nicht deklariert, ob erforderlich"
      },
      "optional": "optional",
      "required": "erforderlich",
      "typeNotDeclared": "Typ nicht deklariert",
      "typeUnion": "{{kinds}} oder {{last}}",
      "unfilled": "nichts füllt sie",
      "unused": "kein späterer Schritt nutzt sie",
      "used": "ein späterer Schritt nutzt sie"
    },
    "projectTool": "Projektwerkzeug",
    "releaseParts": {
      "metadata": "Titel, Lizenz und Beschreibung",
      "what": "was hineinkommt",
      "where": "wohin sie geht"
    },
    "results": {
      "annotations": "Annotationen",
      "change_set": "Änderungssatz",
      "choice": "Auswahl",
      "instance_data": "Aussagen",
      "reviewed": "gesichtet",
      "workspace_file": "Datei"
    },
    "selectors": {
      "competency_questions": "Kompetenzfragen",
      "few_shot_examples": "Few-shot-Beispiele",
      "label_list": "Labelliste"
    },
    "showInThread": "Im Durchlauf",
    "showInThreadNamed": "{{name}} im Durchlauf zeigen",
    "showSettingsNamed": "Einstellungen von {{name}} zeigen",
    "state": "Stand: {{state}}",
    "steps_one": "{{count}} Schritt",
    "steps_other": "{{count}} Schritte",
    "takes": "Nimmt {{ports}}",
    "termKinds": {
      "annotation_property": "Annotationseigenschaften",
      "class": "Klassen",
      "datatype_property": "Datentypeigenschaften",
      "individual": "Individuen",
      "object_property": "Objekteigenschaften"
    },
    "termKindsAll": "Begriffe",
    "termKindsMany": "{{first}} und {{last}}",
    "termsOfModel": "{{kinds}} des Datenmodells",
    "termsOfModules": "{{kinds}} aus {{modules}}"
  },
  "outline": {
    "feeds": "Speist: {{steps}}",
    "inputs": "Eingabevorbereitung",
    "pipeline": "Hauptablauf"
  },
  "view": {
    "collapseAll": "Alle Eingaben zuklappen",
    "definition": "Definition anzeigen",
    "display": "Ansicht",
    "displays": {"graph": "Graph", "list": "Liste"},
    "expandAll": "Alle Eingaben aufklappen",
    "loading": "Prozessschema wird geladen …",
    "run": "Durchlauf starten…"
  }
}
